import { render, staticRenderFns } from "./Number_people.vue?vue&type=template&id=47322567&scoped=true&"
import script from "./Number_people.vue?vue&type=script&lang=js&"
export * from "./Number_people.vue?vue&type=script&lang=js&"
import style0 from "./Number_people.vue?vue&type=style&index=0&id=47322567&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47322567",
  null
  
)

export default component.exports